// @ts-nocheck
import { AssetInfoType } from "./types";
import {
  STRAXLogo,
  PRIMELogo,
  TRBLogo,
  INJLogo,
  BLURLogo,
  MINALogo,
  MEMELogo,
  TAOLogo,
  BONKLogo,
  LDOLogo,
  APTLogo,
  PYTHLogo,
  NTRNLogo,
  DOGELogo,
  TRXLogo,
  BLASTLogo,
  BEAMXLogo,
  ILVLogo,
  JUPLogo,
  RNDRLogo,
  ORDILogo,
  JITOLogo,
  SATSLogo,
  ATOMLogo,
  DYMLogo,
  MANTALogo,
  ALTLogo,
  SUILogo,
  UMALogo,
  ZETALogo,
  PIXELLogo,
  STRKLogo,
  SHFLLogo,
  PORTALLogo,
  PARCLLogo,
  ARLogo,
  TONLogo,
  MONLogo,
  BTCLogo,
  ETHLogo,
} from "./logos";

export const assetsPart2: AssetInfoType = {
  STRAX: {
    logo: STRAXLogo,
    name: "STRAX",
    description:
      "The Stratis BaaS platform is designed for financial service providers and other enterprises to test, develop and deploy blockchain-based applications in a way that avoids the overhead and security concerns of operating their own networks.",
  },
  PRIME: {
    logo: PRIMELogo,
    name: "PRIME",
    description:
      "The Echelon Prime Foundation (EPF) is an ecosystem revolutionising game economies for players and builders. Parallel TCG — the first game to leverage Echelon’s tools — uses PRIME, an Ethereum token, to power unique in-game functions and companion apps.",
  },
  TRB: {
    logo: TRBLogo,
    name: "TRB",
    description:
      "Tellor is a transparent and permissionless oracle protocol for smart contracts to easily get any data whenever it needs it.",
  },
  INJ: {
    logo: INJLogo,
    name: "INJ",
    description:
      "Injective is the fastest blockchain built for finance and plug-and-play Web3 modules. It's ecosystem aims to reshape a broken financial system with dApps that are highly interoperable, scalable and truly decentralized.",
  },
  BLUR: {
    logo: BLURLogo,
    name: "BLUR",
    description:
      "Blur is a NFT marketplace where you can sweep NFTs across multiple marketplaces, snipe reveals faster than others, and manage your portfolio with advanced analytics.",
  },
  MINA: {
    logo: MINALogo,
    name: "MINA",
    description:
      "Mina is building a privacy and security layer for web3 with zero knowledge proofs.",
  },
  MEME: {
    logo: MEMELogo,
    name: "MEME",
    description:
      "Memecoin (MEME) is the native ecosystem token of Memeland. Memeland is the web3 venture studio by 9GAG, the globally popular meme platform.",
  },
  TAO: {
    logo: TAOLogo,
    name: "TAO",
    description:
      "Bittensor (TAO) is an open-source protocol that powers a decentralized, blockchain-based machine learning network.",
  },
  "1000BONK": {
    logo: BONKLogo,
    name: "BONK",
    description:
      "BONK is a decentralized cryptocurrency that was created on the Solana blockchain as the first dog-themed meme coin. It aims to be a fun and community-driven token that can be used across various dApps built on Solana.",
  },
  LDO: {
    logo: LDOLogo,
    name: "Lido DAO",
    description:
      "Lido DAO is a decentralized autonomous organization (DAO) which provides staking infrastructure for multiple blockchain networks.",
  },
  APT: {
    logo: APTLogo,
    name: "APTOS",
    description:
      "Aptos is a Layer 1 blockchain aiming to provide users with enhanced scalability, reliability, security, and usability.",
  },
  PYTH: {
    logo: PYTHLogo,
    name: "PYTH",
    description:
      "Pyth delivers real-time market data for crypto, equities, FX, and commodities to 40+ blockchains. 90+ major market participants — including Jane Street, CBOE, Binance, OKX, and Bybit — contribute data to the network.",
  },
  NTRN: {
    logo: NTRNLogo,
    name: "NTRN",
    description:
      "Powered by Tendermint and built with the Cosmos SDK, Neutron is the a secure permission-less smart contract platform for Interchain DeFi.",
  },
  DOGE: {
    logo: DOGELogo,
    name: "DOGE",
    description:
      'Dogecoin (DOGE) is based on the popular "doge" Internet meme and features a Shiba Inu on its logo.',
  },
  TRX: {
    logo: TRXLogo,
    name: "TRX",
    description:
      "TRON (TRX) is a decentralized blockchain-based operating system developed by the Tron Foundation and launched in 2017.",
  },
  BLAST: {
    logo: BLASTLogo,
    name: "BLAST",
    description:
      "BLAST is an upcoming Ethereum L2 with native yield for ETH and stablecoins. Since the tokenomics have not been released yet, this market assumes that there will be 1,000,000,000 tokens in circulation.",
  },
  BEAMX: {
    logo: BEAMXLogo,
    name: "BEAMX",
    description:
      "The $BEAM token (formerly MC) serves as the native crypto asset for the Beam network, a gaming network empowered by the Merit Circle DAO. Beam represents a collaborative platform where the gaming community, including players and developers, collaborates to drive the gaming sector's evolution.",
  },
  ILV: {
    logo: ILVLogo,
    name: "ILV",
    description:
      'Illuvium is an open-world, role-playing, NFT creature collector "play-to-earn" game running on the Ethereum blockchain. To power its economy, Illuvium uses its native ERC-20 token, $ILV.',
  },
  JUP: {
    logo: JUPLogo,
    name: "JUP",
    description:
      "As a liquidity aggregator on Solana, Jupiter aggregates the best token prices across different decentralized exchanges by connecting all DEX markets and AMM pools together, irrespective of the provider.",
  },
  RNDR: {
    logo: RNDRLogo,
    name: "RNDR",
    description:
      "RenderToken (RNDR) is a distributed GPU rendering network built on top of the Ethereum blockchain, aiming to connect artists and studios in need of GPU compute power with mining partners willing to rent their GPU capabilities out.",
  },
  ORDI: {
    logo: ORDILogo,
    name: "ORDI",
    description:
      "ORDI is the first token created in accordance with the BRC-20 fungible token standard on the Bitcoin blockchain.",
  },
  JITO: {
    logo: JITOLogo,
    name: "JITO",
    description:
      "Jito Foundation is launching a governance token aimed at both managing and spurring development of the Solana-based liquid staking protocol.",
  },
  "10000SATS": {
    logo: SATSLogo,
    name: "SATS",
    description:
      "Sats is a memecoin created on Bitcoin through the Ordinals protocol, named after ‘satoshis,’ the smallest unit of Bitcoin.",
  },
  ATOM: {
    logo: ATOMLogo,
    name: "ATOM",
    description:
      "The Cosmos network consists of many independent, parallel blockchains, called zones, each powered by classical Byzantine fault-tolerant (BFT) consensus protocols like Tendermint (already used by platforms like ErisDB).",
  },
  DYM: {
    logo: DYMLogo,
    name: "DYM",
    description:
      "Dymension is a modular blockchain platform with built-in roll-ups technology for scalability.",
  },
  MANTA: {
    logo: MANTALogo,
    name: "MANTA",
    description:
      "Manta Network is the plug-and-play privacy-preservation protocol built to service the entire DeFi stack.",
  },
  ALT: {
    logo: ALTLogo,
    name: "ALT",
    description:
      "AltLayer is a decentralized protocol that facilitates the launch of native and restaked rollups with both optimistic and zk rollup stacks.",
  },
  SUI: {
    logo: SUILogo,
    name: "SUI",
    description:
      "Sui is a first-of-its-kind Layer 1 blockchain and smart contract platform designed from the bottom up to make digital asset ownership fast, private, secure, and accessible to everyone.",
  },
  UMA: {
    logo: UMALogo,
    name: "UMA",
    description:
      "UMA is an optimistic oracle (OO) that can record any knowable truth onto a blockchain. It tells smart contracts “things about the world” so contracts and markets asking for that data can be settled.",
  },
  ZETA: {
    logo: ZETALogo,
    name: "ZETA",
    description:
      "ZetaChain is an EVM-compatible L1 blockchain that connects everything. Developers are able to build interoperable dApps that span any chain including Bitcoin.",
  },
  PIXEL: {
    logo: PIXELLogo,
    name: "PIXEL",
    description:
      "Pixels (PIXEL) is a social web3 game built on the Ronin Network.",
  },
  STRK: {
    logo: STRKLogo,
    name: "STRK",
    description:
      "StarkNet is a permissionless decentralized Validity-Rollup (also known as a “ZK-Rollup”). It operates as an L2 network over Ethereum, enabling any dApp to achieve unlimited scale for its computation – without compromising Ethereum’s composability and security, thanks to StarkNet’s reliance on the safest and most scalable cryptographic proof system – STARK.",
  },
  SHFL: {
    logo: SHFLLogo,
    name: "SHFL",
    description:
      "Shuffle is a leading crypto casino and sports betting platform launched in February 2023. SHFL will be tightly integrated with the core platform, reward the most active users, build the community, and take the player experience to new heights.",
  },
  PORTAL: {
    logo: PORTALLogo,
    name: "PORTAL",
    description:
      "$PORTAL is the native platform coin for the portal platform. $PORTAL acts as a nexus of web3 games and gamers, providing game distribution and player simplicity for all.",
  },
  PARCL: {
    logo: PARCLLogo,
    name: "PARCL",
    description:
      "Parcl is a decentralized real estate trading platform. Parcl offers city indexes that allow you to speculate on price movements of real estate markets across the globe.",
  },
  AR: {
    logo: ARLogo,
    name: "AR",
    description:
      "Arweave is a decentralized storage network that seeks to offer a platform for the indefinite storage of data.",
  },
  TON: {
    logo: TONLogo,
    name: "TON",
    description:
      "TON is a decentralized and open internet, created by the community using a technology designed by Telegram.",
  },
  WNATIVE: {
    logo: MONLogo,
    name: "Wrapped Native",
    description:
      "Wrapped native token of the chain (e.g., WETH on Ethereum, WMON on Monad).",
  },
  mWBTC: {
    logo: BTCLogo,
    name: "Mock Wrapped Bitcoin",
    description:
      "Mock Wrapped Bitcoin token used on testnets.",
  },
  WETH: {
    logo: ETHLogo,
    name: "Wrapped Ethereum",
    description:
      "Wrapped Ether (WETH) is an ERC-20 compatible version of Ether (ETH).",
  },
  WBTC: {
    logo: BTCLogo,
    name: "Wrapped Bitcoin",
    description:
      "Wrapped Bitcoin (WBTC) is an ERC-20 token that represents Bitcoin on the Ethereum blockchain.",
  },
};
